import React from "react";
import ReactDOM from "react-dom";

import { observer, inject, Provider } from "mobx-react";
import { extendObservable } from 'mobx';

import { Link } from "react-router-dom";

import PriceList    from './PriceList'
import Quantity     from './Quantity'
import NewStoreButton from './NewStoreButton'
import NewProductButton from './NewProductButton'


@inject('core')
@observer
export default class Footer extends React.Component {
	
	componentDidMount() {
		const { core } = this.props
		
		
	}

	render() {
		const { core, path } = this.props
/*
		switch(path) {
			case '/:pod_id/stores':
				return <div id="footer"><NewStoreButton /></div>
				break;
				
			case '/:pod_id/store/:store_id':
			case '/:pod_id/':
				return <div id="footer"><NewProductButton /></div>
				break;
				
			default:
				return <div id="footer">{path}</div>
		}		
	*/
	
		return <div id="footer">
			<span id="sync-status" className={ 
						(core.syncQueue.length ? 'populated' : 'empty') 
						+ ' ' 
						+ (core.syncQueue.find(o => o.synced == 'syncing') ? 'active' : '') } />
		</div>
	}
}


